import { productRecommendations } from '../data/products';

export function calculateRecommendation(answers: Record<string, string[]>) {
  // Primeira pergunta define o nível de calvície
  const hairLossStage = answers['1']?.[0]; // 'grau-1-2', 'grau-3-4', ou 'grau-5'
  
  let calvicieLevel: 'inicial' | 'moderada' | 'avancada' = 'inicial';
  
  if (hairLossStage === 'grau-1-2') {
    calvicieLevel = 'inicial';
  } else if (hairLossStage === 'grau-3-4') {
    calvicieLevel = 'moderada';
  } else if (hairLossStage === 'grau-5') {
    calvicieLevel = 'avancada';
  }

  // Pergunta 6 - Condição do couro cabeludo
  const scalpCondition = answers['6']?.[0];
  let condicaoCouro = 'normal';
  
  if (scalpCondition === 'oleoso') {
    condicaoCouro = 'oleoso';
  } else if (scalpCondition === 'caspa') {
    condicaoCouro = 'caspa';
  } else if (scalpCondition === 'ambos') {
    condicaoCouro = 'oleoso e caspa';
  }

  // Análise adicional baseada nas outras respostas
  const age = answers['2']?.[0];
  const duration = answers['3']?.[0];

  let analysisText = '';
  
  if (calvicieLevel === 'inicial') {
    analysisText = 'Você está no estágio inicial da calvície (Graus 1-2). Este é o momento ideal para começar um tratamento preventivo e estimular o crescimento capilar.';
  } else if (calvicieLevel === 'moderada') {
    analysisText = 'Você está no estágio moderado da calvície (Graus 3-4). É importante agir agora com um tratamento intensivo para recuperar e fortalecer os fios.';
  } else {
    analysisText = 'Você está no estágio avançado da calvície (Grau 5). Recomendamos um tratamento completo e intensivo para estimular o máximo de recuperação possível.';
  }

  // Adiciona informações sobre idade e duração
  if (age === '18-25' && duration === 'recent') {
    analysisText += ' Como você é jovem e notou a queda recentemente, há grandes chances de recuperação com o tratamento adequado.';
  } else if (duration === 'long') {
    analysisText += ' Embora a queda seja de longa data, ainda é possível obter resultados significativos com persistência no tratamento.';
  }

  // Busca a recomendação de produto baseada no nível de calvície
  const recommendation = productRecommendations[calvicieLevel]?.default || productRecommendations.inicial.default;

  return {
    product: recommendation,
    analysis: analysisText,
    calvicieLevel,
    condicaoCouro,
  };
}
